// Loyalty push notification helpers.
//
// Reuses the admin service worker (/sw.js) — the SW is generic and fires a
// browser notification for any push payload with { title, body, url }.

import { loyaltyPushVapidKey, loyaltyPushSubscribe, loyaltyPushUnsubscribe } from "./api";

function urlBase64ToUint8Array(base64) {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const raw = window.atob((base64 + padding).replace(/-/g, "+").replace(/_/g, "/"));
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function loyaltyPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export function loyaltyPushStatus() {
  if (!loyaltyPushSupported()) return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

async function _registerSw() {
  const reg = (await navigator.serviceWorker.getRegistration("/sw.js")) || (await navigator.serviceWorker.register("/sw.js"));
  await navigator.serviceWorker.ready;
  return reg;
}

export async function loyaltyPushEnable() {
  if (!loyaltyPushSupported()) throw new Error("Push non supportate su questo dispositivo");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permesso notifiche negato");
  const key = await loyaltyPushVapidKey();
  if (!key) throw new Error("Chiave VAPID non configurata sul server");
  const reg = await _registerSw();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(key),
    });
  }
  const raw = sub.toJSON();
  await loyaltyPushSubscribe({
    endpoint: raw.endpoint,
    keys: { p256dh: raw.keys.p256dh, auth: raw.keys.auth },
  });
  return true;
}

export async function loyaltyPushDisable() {
  if (!loyaltyPushSupported()) return;
  const reg = await navigator.serviceWorker.getRegistration("/sw.js");
  if (!reg) return;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    try { await loyaltyPushUnsubscribe(sub.endpoint); } catch (_) {}
    try { await sub.unsubscribe(); } catch (_) {}
  }
}
